import { SubmitButton } from "@avenue-8/sidekick-ui";
import { useAdminImpersonateAction } from "@features/Users/useAdminImpersonateAction";

type Props = {
  isLoading: boolean;
  userName: string | undefined;
  userEmail: string;
  fullWidth?: boolean;
};

export const AdminImpersonateUser = (props: Props) => {
  const { isLoading, userName, userEmail, fullWidth } = props;
  const { impersonate, isPending } = useAdminImpersonateAction();

  const handleImpersonateClick = () => {
    impersonate({ email: userEmail, name: userName });
  };

  return (
    <SubmitButton
      type="button"
      variant="outlined"
      size={fullWidth ? "medium" : "small"}
      fullWidth={fullWidth}
      onClick={handleImpersonateClick}
      isLoading={isLoading || isPending}
      loadingText="Impersonating..."
    >
      Impersonate user
    </SubmitButton>
  );
};
